import styled, { css } from 'styled-components';
import { Loader as LoaderComponent, Stack } from 'src/components';

export const Root = styled.div(
  ({ theme }) => css`
    align-items: center;
    background-color: ${theme.co.neutral99};
    color: ${theme.co.neutral20};
    display: flex;
    font-size: ${theme.sz.s3};
    height: 100%;
    min-height: 100dvh;
    min-width: 100vw;
    width: 100%;
  `,
);

export const Content = styled.div(
  () => css`
    width: 100%;
  `,
);

export const Header = styled.p(
  ({ theme }) => css`
    font-family: ${theme.DEPRECATED_ty.boing};
    color: ${theme.co.secondary20};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.sz.s10};
    text-align: center;
    margin: 0 0 ${theme.sz.s4} 0;

    @media (max-width: ${theme.sz.md}) {
      font-size: ${theme.sz.s6};
    }
  `,
);

export const FullWidthFloatingPortal = styled.div(
  ({ theme }) => css`
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: ${theme.zi.z5};
  `,
);

export const ContentWrapper = styled(Stack)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s8};
    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s4} ${theme.sz.s4} 0 ${theme.sz.s4};
    }
  `,
);

export const Loader = styled(LoaderComponent)`
  margin-top: ${props => props.theme.sz.s40};
  width: ${props => props.theme.sz.s12};

  @media (min-width: ${props => props.theme.sz.xl}) {
    width: ${props => props.theme.sz.s40};
  }
`;

export const LoaderWrapper = styled.div(
  () => css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);

export const ListWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;

    ul {
      overflow-y: inherit;
    }

    @media (min-width: ${theme.sz.md}) {
      width: 100%;
    }
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s4} 0;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};

    @media (max-width: ${theme.sz.md}) {
      margin: 0;
    }
  `,
);

export const SettingsIconWrapper = styled.button(
  ({ theme }) => css`
    position: fixed;
    bottom: ${theme.sz.s12};
    left: ${theme.sz.s12};
    padding: 0;
    font-size: ${theme.sz.s10};
    height: ${theme.sz.s12};
    width: ${theme.sz.s12};
    cursor: pointer;
    display: flex;
    align-items: end;
    justify-content: space-around;
    border-radius: ${theme.bo.round};
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral98};
    background: ${theme.co.neutral99};
    color: ${theme.co.secondary0};
    box-shadow: 0 3.84px 0 ${theme.co.neutral95};

    &:hover {
      background: ${theme.co.neutral98};
      color: ${theme.co.secondary60};
    }

    &:active {
      background: ${theme.co.neutral95};
      color: ${theme.co.secondary50};
    }

    @media (max-width: ${theme.sz.ml}) {
      display: none;
    }
  `,
);
